var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.data,"fields":_vm.fields,"responsive":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }